import { render } from "./AllWhoresPage.vue?vue&type=template&id=13b9ba72&scoped=true"
import script from "./AllWhoresPage.vue?vue&type=script&lang=js"
export * from "./AllWhoresPage.vue?vue&type=script&lang=js"

import "./AllWhoresPage.vue?vue&type=style&index=0&id=13b9ba72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b9ba72"]])

export default __exports__